/* ======================
   CART DRAWER (REN0XA SAFE)
====================== */

// Open / close drawer

window.openCartDrawer = function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.style.transform = 'translateX(0)';
  drawer.setAttribute('data-open', 'true');
  // Add overlay for click-outside detection
  if (!document.getElementById('cart-drawer-overlay')) {
    const overlay = document.createElement('div');
    overlay.id = 'cart-drawer-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.zIndex = '9998';
    overlay.style.background = 'rgba(0,0,0,0.4)'; // semi-gray transparent
    overlay.addEventListener('mousedown', function (e) {
      // Always close on any click to overlay (outside drawer)
      window.closeCartDrawer();
    });
    document.body.appendChild(overlay);
  }
};


window.closeCartDrawer = function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.style.transform = 'translateX(100%)';
  drawer.removeAttribute('data-open');
  // Remove overlay if present
  const overlay = document.getElementById('cart-drawer-overlay');
  if (overlay) overlay.remove();
};

// Fetch full cart and render using theme.liquid's renderCartDrawer
window.updateCartDrawer = function () {
  return fetch('/cart.js', { cache: 'no-store' })
    .then(res => res.json())
    .then(cart => {
      if (typeof window.renderCartDrawer === 'function') {
        window.renderCartDrawer(cart);
      }
    })
    .catch(err => console.error('Failed to load cart', err));
};

// Intercept Add To Cart

document.addEventListener('click', function (e) {
  const btn = e.target.closest('button, input[type="submit"]');
  if (!btn) return;

  const form = btn.closest('form[action="/cart/add"]');
  if (!form) return;


  // No longer block add-to-cart if drawer is open

  e.preventDefault();
  e.stopImmediatePropagation();

  const data = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: data,
    headers: { 'Accept': 'application/json' }
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart error');
    return res.json();
  })
  .then(() => {
    // After add succeeds, fetch full cart to update drawer and open it
    updateCartDrawer().then(() => {
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }
    });
  })
  .catch(err => console.error('Add to cart failed:', err));
});

// Intercept cart icon click
document.addEventListener('click', function (e) {
  const cartLink = e.target.closest('a[href="/cart"]');
  if (!cartLink) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  updateCartDrawer().then(() => {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    }
  });
});
